<template>
  <section class="ns">
    <div class="ns__item">
      <h4>Seleccione el orden de atención de chats</h4>
      <a-radio-group v-model:value="distributionType">
        <a-radio v-for="item of distributions" :key="item.value" :value="item.value">
          <span> {{ item.label }} </span>
          <a-tooltip :title="item.tooltip">
            <InfoCircleOutlined class="tooltip__icon" theme="filled" />
          </a-tooltip>
        </a-radio>
      </a-radio-group>
    </div>

    <div class="ns__item">
      <h4>Configure la cantidad de tickets que se entregarán por agente</h4>
      <a-form layout="inline">
        <a-form-item label="Número de tickets">
          <a-input-number v-model:value="maxTicketsAgents" :min="1" />
        </a-form-item>
      </a-form>
    </div>

    <div class="ns__item">
      <h4>Configure el tiempo de nivel de servicio de la cola</h4>
      <second-input
        :value="levelService"
        @update:value="levelService = $event"
        label="Nivel de servicio"
      />
      <second-input
        :value="waitingThreshold"
        @update:value="waitingThreshold = $event"
        label="Umbral de espera"
      />
    </div>
  </section>
</template>

<script>
import SecondInput from "@/app/shared/components/inputs/SecondInput.vue";
import { defineComponent } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

const distributions = [
  {
    label: "FIFO",
    tooltip:
      "En FIFO los chats serán atendidos en el orden de primero en entrar, primero en salir.",
    value: 1,
  },
  {
    label: "LIFO",
    tooltip: "En LIFO los chats serán atendidos en el orden de último en entrar, primero en salir.",
    value: 2,
  },
];

export default defineComponent({
  components: {
    SecondInput,
    InfoCircleOutlined,
  },
  data() {
    return {
      distributions,
    };
  },
  computed: {
    levelService: {
      get() {
        return this.$store.getters["getQueueState"].level_service;
      },
      set(level_service) {
        this.$store.dispatch("setQueueProperties", { level_service });
      },
    },
    waitingThreshold: {
      get() {
        return this.$store.getters["getQueueState"].waiting_threshold;
      },
      set(waiting_threshold) {
        this.$store.dispatch("setQueueProperties", { waiting_threshold });
      },
    },
    distributionType: {
      get() {
        return this.$store.getters["getQueueState"].distribution_type;
      },
      set(distribution_type) {
        this.$store.dispatch("setQueueProperties", { distribution_type });
      },
    },
    maxTicketsAgents: {
      get() {
        return this.$store.getters["getQueueState"].max_tickets_agents;
      },
      set(max_tickets_agents) {
        this.$store.dispatch("setQueueProperties", { max_tickets_agents });
      },
    },
  },
  methods: {
    handleOk(current) {
      return current + 1;
    },
  },
});
</script>

<style lang="sass" scoped>
.ns
  margin: 0 auto
  max-width: 600px
  display: flex
  flex-direction: column
  align-items: center

  &__item
    display: flex
    flex-direction: column
    align-items: center
    padding-bottom: 24px

    & h4
      margin-bottom: 12px

.tooltip
  &__icon
    color: $gray-6
    margin-left: 4px
</style>
